import React from 'react';
import { ICON_MAP } from './iconMapper';
import Close from '../../../assets/Close';

interface IconPickerModalProps {
    availableIcons: string[];
    onClose: () => void;
    onSelect: (iconId: string) => void;
}

const IconPickerModal: React.FC<IconPickerModalProps> = ({ availableIcons, onClose, onSelect }) => {
    return (
        <div className="icon-picker-overlay">
            <div className="icon-picker-modal">
                <div className="icon-picker-header">
                    <h3>Select an Icon</h3>
                    <button className="btn-close-modal" onClick={onClose}>
                        <Close />
                    </button>
                </div>
                
                <div className="icon-picker-content">
                    <p className="picker-hint">Choose an icon that best represents your value proposition.</p>
                    <div className="icon-grid">
                        {availableIcons.map(iconId => {
                            const IconComponent = ICON_MAP[iconId];
                            
                            return (
                                <div 
                                    key={iconId} 
                                    className="icon-card" 
                                    onClick={() => onSelect(iconId)}
                                    title={iconId.replace(/-/g, ' ')}
                                >
                                    <div className="icon-card-svg">
                                        {IconComponent && <IconComponent width="40px" height="40px" />}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="icon-picker-footer">
                    <button className="btn btn-outline-secondary" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default IconPickerModal;